import z from 'zod';
import {firestoreTimestampToDateSchema} from '../_other/firestore/firestoreTimestampToDateSchema';
import {todoRepeatUnitSchema} from './TodoRepeatUnit';

/** 0=Sunday, 1=Monday, ..., 6=Saturday */
const dayOfWeekSchema = z.number().min(0).max(6);

export const repeatSchema = z.object({
  unit: todoRepeatUnitSchema,
  number: z.number().positive().optional(),
  startDate: firestoreTimestampToDateSchema,
  daysOfWeek: z.array(dayOfWeekSchema).optional(),
});

export interface Repeat extends z.infer<typeof repeatSchema> {}
